var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('modal-close-button', {
    attrs: {
      "aria-label": "Zavrieť príjem",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.closePopup
    }
  }), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(" " + _vm._s(_vm.typeLabel) + " ")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "income-submit",
      "disabled": _vm.busy
    }
  }, [_vm._v(_vm._s(_vm.busy ? "Prepočítavam…" : "Uložiť"))])], 1), _vm.busy ? _c('div', {
    staticClass: "income-save-status",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 22,
      "width": 2
    }
  }), _vm._m(0)], 1) : _vm._e(), _vm.saveError ? _c('p', {
    staticClass: "clientError",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _c('fieldset', {
    staticClass: "income-fields",
    attrs: {
      "disabled": _vm.busy,
      "aria-busy": String(_vm.busy)
    }
  }, [_c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "income": _vm.payload,
      "form-template": _vm.form,
      "meta-data": _vm.metaData,
      "client-info": _vm.clientInfo
    },
    on: {
      "income-saved": function incomeSaved($event) {
        return _vm.saveIncome($event);
      },
      "income-preparing": function incomePreparing($event) {
        _vm.preparing = $event;
      },
      "income-save-error": function incomeSaveError($event) {
        _vm.saveError = $event;
      }
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('strong', [_vm._v("Ukladám príjem a prepočítavam hypotéku")]), _c('br'), _vm._v("Aktualizujem mesačný príjem, limity a ponuky bánk. Môže to chvíľu trvať.")]);

}]

export { render, staticRenderFns }